import React, { useEffect } from 'react'
import "./faq.css";
import { faqClick } from "../services/adobeDataLayer";
// import Aos from "aos";
// import 'aos/dist/aos.css'

function Faq() {
    const initFaq = () => {
        document.querySelectorAll(".faq-question").forEach((question) => {
            question.onclick = () => {
                const item = question.parentElement;
                const answer = item.querySelector(".faq-answer");
                const isActive = item.classList.contains("active");
                document.querySelectorAll(".faq-item").forEach((el) => {
                    el.classList.remove("active");
                    const ans = el.querySelector(".faq-answer");
                    if (ans) ans.style.maxHeight = null;
                });
                if (!isActive) {
                    item.classList.add("active");
                    answer.style.maxHeight = answer.scrollHeight + "px";
                }
                const questionText = question.querySelector("h3")?.textContent || "faq";
                faqClick(questionText);
                window.dispatchEvent(new CustomEvent("adobeCTAClick"));
            };
        });
        document.querySelectorAll(".faq-item.active .faq-answer").forEach((answer) => {
            answer.style.maxHeight = answer.scrollHeight + "px";
        });
        window.addEventListener("resize", handleResize);
        const viewMoreBtn = document.querySelector(".view-more-btn");
        const hiddenWrapper = document.querySelector(".hidden-faq-wrapper");

        if (viewMoreBtn && hiddenWrapper) {
            viewMoreBtn.onclick = () => {
                const isExpanded = hiddenWrapper.classList.contains("expanded");
                hiddenWrapper.classList.toggle("expanded");
                viewMoreBtn.textContent = isExpanded ? "View More" : "View Less";
                faqClick("faq");
                window.dispatchEvent(new CustomEvent("adobeCTAClick"));
            };
        }
    };
    const handleResize = () => {
        document
            .querySelectorAll(".faq-item.active .faq-answer")
            .forEach((answer) => {
                answer.style.maxHeight = answer.scrollHeight + "px";
            });
    };
    const cleanupFaq = () => {
        window.removeEventListener("resize", handleResize);
        document.querySelectorAll(".faq-question").forEach((q) => {
            q.onclick = null;
        });
        const viewMoreBtn = document.querySelector(".view-more-btn");
        if (viewMoreBtn) viewMoreBtn.onclick = null;
    };
    useEffect(() => {
        // Aos.init({
        //     once: true,
        //     duration: 500,
        // });
        initFaq();
        return cleanupFaq;
    }, [])

    return (
        <>
            <section className="faq-section">
                <div className="container-lg">
                    <div className="faq-wrapper">
                        <div className='row justify-content-center'>
                            <div className='col-xxl-10'>
                                <h2 data-aos="fade-up" data-aos-delay="0">Frequently Asked Questions</h2>
                                <div className="pt-4 pb-5">
                                    <div className="faq-item active" data-aos="fade-up" data-aos-delay="200">
                                        <div className="faq-question">
                                            <button className="toggle-btn" aria-label="FAQs open">
                                                <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                            </button>
                                            <h3>What is the Salary eligibility for opening a Salary Account?</h3>
                                        </div>
                                        <div className="faq-answer">
                                            <p>Any individual employed in any organisation and drawing a monthly salary can open a Salary Account with ICICI Bank. ICICI Bank offers Salary Account for every life stage basis the salary bracket.</p>
                                        </div>
                                    </div>

                                    <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                        <div className="faq-question">
                                            <button className="toggle-btn" aria-label="FAQs open">
                                                <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                            </button>
                                            <h3>What documents are required in opening a Salary account with ICICI Bank?</h3>
                                        </div>
                                        <div className="faq-answer">
                                            <p>You need the following documents to open a Salary Account with ICICI Bank:</p>
                                            <ol>
                                                <li>Original PAN Card</li>
                                                <li>Original Aadhar Card</li>
                                                <li>Proof of Employment</li>
                                            </ol>
                                        </div>
                                    </div>

                                    <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                        <div className="faq-question">
                                            <button className="toggle-btn" aria-label="FAQs open">
                                                <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                            </button>
                                            <h3>Do we have to maintain any Average Balance in a Salary Account once it is active?</h3>
                                        </div>
                                        <div className="faq-answer">
                                            <p>No, there is no requirement to maintain Average Monthly Balance in case of a Salary Account.</p>
                                        </div>
                                    </div>

                                    <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                        <div className="faq-question">
                                            <button className="toggle-btn" aria-label="FAQs open">
                                                <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                            </button>
                                            <h3>Do we get a Debit Card with a Salary Account?</h3>
                                        </div>
                                        <div className="faq-answer">
                                            <p>Yes.</p>
                                        </div>
                                    </div>

                                    <div className="hidden-faq-wrapper">

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>Are there any charges for a Debit Card?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>Debit Card offered with a Salary Account is complimentary except for Regular Salary Account.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>Will I get a Cheque Book for my Salary Account?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>Yes.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>Do we get any Insurance benefit with a Salary Account? If yes, what is the condition to get the claim?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>
                                                    A salaried customer who is getting salary credit in ICICI Bank Account will get Personal Accidental Death Insurance and Air Accidental Death Insurance basis his/her Salary Account variant.
                                                    For more information,
                                                    <a href="https://www.icicibank.com/personal-banking/accounts/savings-account/insurance-cover/terms-and-conditions" rel="noopener noreferrer" target="_blank">click here</a>.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>Can we extend the Salary Account benefits to Family Members?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>Yes, you can extend Salary Account benefits to 5 more accounts – parents, spouse &amp; children.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>If we have an existing ICICI Bank Savings Account, can we convert the same to a Salary Account?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>Yes, you will have to submit your bank account details to your Company HR and update Company details through the iMobile App.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>Is there any RM assigned to Salary Account Customers?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>Yes, an RM is assigned to Salaried Customers basis the Account variant.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>Why do I have to add nominee to my Salary Account?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>Nominee addition is necessary because in case of any unfortunate event with the account holder, the nominee will obtain all the benefits and funds.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>What are the different channels through which I can access my ICICI Bank Salary Account?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <ol>
                                                    <li>ICICI Bank Branch</li>
                                                    <li>ICICI Bank ATMs</li>
                                                    <li>ICICI Bank Phone Banking</li>
                                                    <li>ICICI Bank Mobile Banking</li>
                                                    <li>ICICI Bank WhatsApp Banking</li>
                                                </ol>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>How do I update mobile number for my ICICI Bank Salary Account?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>You can update the mobile number through any of the following channels:</p>
                                                <p className="mb-0"><b>ICICI Bank ATM:</b></p>
                                                <p>Visit any ICICI Bank ATM &gt; Select ‘More options’ &gt; Register your mobile number &gt; Enter the mobile number. Your mobile number will be updated in one working day.</p>
                                                <p className="mb-0"><b>ICICI Bank Branch:</b></p>
                                                <p>Please visit any ICICI Bank Branch along with your original photo ID proof. Once the request is made, your mobile number will be updated in &lt;2&gt; working days. To locate the nearest ICICI Bank Branch, visit&nbsp;<a href="http://maps.icicibank.com/mobile">maps.icicibank.com/mobile.</a></p>
                                                <p>We have discontinued mobile number registration/ de-registration/ modification through our Customer Care and Internet Banking due to security reasons.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>How do I generate my Internet Banking Password?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>You will be able to place a request for Internet Banking Password through the below mentioned channels:</p>
                                                <p className="mb-0"><b>Internet Banking:</b></p>
                                                <p>You can generate your login password at www.icicibank.com &gt; Click on ‘Internet Banking’ (Bottom of the page) &gt; ‘Get Started’ &gt; ‘I Want my Password’</p>
                                                <p className="mb-0"><b>Customer Care:</b></p>
                                                <p>You may place a request by calling our Customer Care between 7:00 a.m. and 9:00 p.m. from your registered mobile number. To know the Customer Care numbers, we request you to&nbsp;<a href="https://www.icicibank.com/customer-care.page"><b>click here</b></a><b>&nbsp;.</b></p>
                                                <p className="mb-0"><b>ICICI Bank Branch:</b></p>
                                                <p>Visit any ICICI Bank Branch along with original photo ID proof.</p>
                                            </div>
                                        </div>

                                        <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
                                            <div className="faq-question">
                                                <button className="toggle-btn" aria-label="FAQs open">
                                                    <img src="dist/img/plus.svg" alt="" width="20" height="20" />
                                                </button>
                                                <h3>How do I port my ICICI Bank Salary Account from one branch to another?</h3>
                                            </div>
                                            <div className="faq-answer">
                                                <p>You can transfer your account from one branch to another using iMobile App or Internet Banking.</p>
                                                <p><b>Using iMobile App:</b><br />
                                                    iMobile App &gt; Login &gt; Services &gt; Account Services &gt; Transfer Your Accounts &gt; Select Account number &gt; Yes &gt; Select State / Select Branch.</p>
                                                <p><b>Using Internet Banking:</b><br />
                                                    Internet Banking &gt; My Accounts &gt; Bank Accounts &gt; Service Requests &gt; Transfer Your Account Online &gt; Account will be transferred within 2 working days.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="view-more-btn" data-aos="fade-up" data-aos-delay="500">View More</button>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
        </>
    );
}

export default Faq;
